/*jshint esversion: 6 */

export default (function(selector){

    let player;

    let clearVideoTriggers = function(selector) {
        let elems = document.querySelectorAll(selector);
        for (let i = 0; i < elems.length; i++) {
            elems[i].classList.remove("active");
        }
    }

    let iframe = document.querySelector('iframe');
    if (typeof Vimeo == "undefined") {
        console.log("Warning: the Vimeo object is not available");
        return;
    } else {
        player = new Vimeo.Player(iframe);
        if (typeof player == "undefined") {
            console.log("Warning: the video player object is undefined");
            return;
        }
    }

    let elems = document.querySelectorAll(selector);
    if (elems.length < 1) {
        return;
    }

    for (let i = 0; i < elems.length; i++) {
        let advance = parseInt(elems[i].getAttribute("advance"));
        if (Number.isInteger(advance)) {
            elems[i].onclick = (function(selector){
                return function () {
                    clearVideoTriggers(selector);
                    this.classList.add("active");
                    player.setCurrentTime(this.getAttribute("advance"));
                }
            })(selector);
        } else {
            elems[i].onclick = (function(){
                return function () {
                    console.log('Error: advance is not an integer (check source code)');
                }
            }(selector));
        }
    }

});


